
import PlantsReducer from './plant-items/reducer';
import AddPlantReducer from './add-plant/reducer';
import CardItemReducer from './card-item/reducer';

export const componentReducers = {
  plants: PlantsReducer,
  addPlant: AddPlantReducer,
  cardItem: CardItemReducer,
};
